import React, { FC, useContext, useState } from "react";
import { LocalizeText } from "components/localizer";
import ConfirmDialog from "components/confirmDialog";
import SubscriptionsContext from "contexts/subscriptions";
import { ISubscription } from "reducers/subscriptions";
import { PauseSubscriptionDatePicker } from "./pauseSubscriptionDatePicker";

interface IPauseDates {
    pauseStartDate: string | null;
    pauseEndDate: string | null;
}

interface IProps {
    onSubmitUpdate: (params: Partial<ISubscription>) => void;
    subscription: ISubscription;
}

export const PauseSubscription: FC<IProps> = ({ subscription, onSubmitUpdate }) => {
    const { isPausingSubscription, pauseSubscription } = useContext(SubscriptionsContext);

    const [pendingDates, setPendingDates] = useState<IPauseDates | null>(null);

    const onAccept = async (): Promise<void> => {
        if (!pendingDates) {
            return;
        }
        const success = await pauseSubscription(
            subscription.uuid,
            pendingDates.pauseStartDate,
            pendingDates.pauseEndDate
        );
        if (success) {
            onSubmitUpdate({});
        }
    };

    return (
        <>
            <PauseSubscriptionDatePicker
                subscription={subscription}
                onSubmit={(dates) => setPendingDates(dates)}
            />

            <ConfirmDialog
                open={!!pendingDates}
                title={<LocalizeText tag="pauseSubscription" />}
                description={<LocalizeText tag="confirmPauseDates" />}
                onReject={() => setPendingDates(null)}
                onAccept={onAccept}
                isLoading={isPausingSubscription}
            />
        </>
    );
};
